import script from "./ImageProduct.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageProduct.vue?vue&type=script&setup=true&lang=ts"

import "./ImageProduct.vue?vue&type=style&index=0&id=6ca0f119&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ca0f119"]])

export default __exports__